import Head from 'next/head'
import { SWRConfig } from 'swr'

import { fetchJSON, isBlank, isPresent } from 'utils'

import CollectionComponent from 'components/Collection'

import { Root } from './index.style'

export default function Collection({ collectionTitle, collectionHandle, fallback }) {
  return (
    <SWRConfig
      value={{
        fallback,
      }}
    >
      <Head>
        <title>{[collectionTitle, 'The Armoury'].join(' - ')}</title>
      </Head>
      <Root>
        <CollectionComponent handle={collectionHandle} />
      </Root>
    </SWRConfig>
  )
}

export async function getStaticProps({ params }) {
  const { collection, facets } = await (
    await fetch(`${process.env.API_URI}/collections/${params.uid}?v=2&limit=9`)
  ).json()

  if (isBlank(collection)) return { notFound: true }

  return {
    props: {
      collectionTitle: collection.title,
      collectionHandle: params.uid,
      fallback: {
        [`/collections/${params.uid}?v=2`]: {
          collection,
          facets,
        },
      },
      // Revalidate every 10 minutes
      revalidate: 600,
    },
  }
}

export async function getStaticPaths() {
  const collections = await fetchJSON(`${process.env.API_URI}/collections`)

  const uids = collections?.map(({ handle }) => handle)?.filter(isPresent)
  const paths = uids?.map((uid) => ({ params: { uid } })) || []

  return {
    paths,
    fallback: false,
  }
}
